
export enum TipoNotificacaoEnum {
  AlbumFotoDownloader = 'AlbumFotoDownloader',
  RelatorioMatriz = 'RelatorioMatriz',
}
